// Banker/Underwriter Adjustment feature (BankerAdjustmentExecutionPlan.md Section 3/4.1).
// Mirrors Levridge.BLL.Models.AdjustmentScreenModule and the AdjustmentTableNames constants on
// the backend (Levridge.BLL/Services/Impl/ApplicantBankerAdjustmentService.cs) so a typo in either
// place shows up as "no adjustment found for this field" rather than a silent mismatch.

export const AdjustmentScreenModule = {
  Applicant: "Applicant",
  IncomeSource: "IncomeSource",
  Expenses: "Expenses",
  BalanceSheetAsset: "BalanceSheetAsset",
  BalanceSheetPersonalHolding: "BalanceSheetPersonalHolding",
  BalanceSheetLiability: "BalanceSheetLiability",
  BalanceSheetQuestionnaire: "BalanceSheetQuestionnaire",
};

export const AdjustmentTableName = {
  Applicant: "Applicant",
  ApplicantIncomesource: "ApplicantIncomesource",
  ApplicantExpenses: "ApplicantExpenses",
  ApplicantCashShortTermInvestments: "ApplicantCashShortTermInvestments",
  ApplicantStockBondGovSecurity: "ApplicantStockBondGovSecurity",
  ApplicantAccountNoteReceivable: "ApplicantAccountNoteReceivable",
  ApplicantCashValueLifeInsurance: "ApplicantCashValueLifeInsurance",
  ApplicantOwnPersonalResidence: "ApplicantOwnPersonalResidence",
  ApplicantVestedIntrestPension: "ApplicantVestedIntrestPension",
  ApplicantUnListedStocks: "ApplicantUnListedStocks",
  ApplicantEquityInterestInBusiness: "ApplicantEquityInterestInBusiness",
  ApplicantGeneralAndLimitedPartenershipIntrest: "ApplicantGeneralAndLimitedPartenershipIntrest",
  ApplicantPersonalHolding: "ApplicantPersonalHolding",
  ApplicantNotesPayableBankSecured: "ApplicantNotesPayableBankSecured",
  ApplicantNotesPayableBankUnSecured: "ApplicantNotesPayableBankUnSecured",
  ApplicantNotesPayableOther: "ApplicantNotesPayableOther",
  ApplicantLiability: "ApplicantLiability",
  ApplicantInvestment: "ApplicantInvestment",
  ApplicantAccountsPayable: "ApplicantAccountsPayable",
  ApplicantCreditCardBalance: "ApplicantCreditCardBalance",
  ApplicantMortgageDueWithin: "ApplicantMortgageDueWithin",
  ApplicantMortgageDueBeyond: "ApplicantMortgageDueBeyond",
  ApplicantQuestionnaire: "ApplicantQuestionnaire",
};
